<template>
  <div class="loginCode">
    <div class="page_top">
      <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
      <div class="page_top_title" v-if="$store.state.gameType == 1">
        社区登录码
      </div>
      <div class="page_top_title" v-else>社区绑定码</div>
      <van-icon name="close" v-show="
        $store.state.system == 'android' &&
        applets != 'xcx' &&
        !$store.state.isXcx &&
        $store.state.isInGame
      " @click="closeCommunity" />
    </div>
    <div class="loginCode_content">
      <span class="tip">绑定码用于 微信小程序、游戏官网 同步游戏内社区数据</span>
      <div class="loginCode_inputbox">
        <div class="loginCode_input_label">绑定码</div>
        <div class="xcxlogin_inputbox">
          <input v-model="password" :type="inoutTpye" id="input_code" />
          <div :class="
            eyesFlag ? 'xcxlogin_input_icon' : 'xcxlogin_input_iconclose'
          " @click="eyesClick"></div>
        </div>
        <div class="loginCode_input_btn" v-clipboard:copy="password" v-clipboard:success="onCopy"
          v-clipboard:error="onError">
          复制
        </div>
      </div>
      <div>
        <p>提示：</p>
        <p>1、绑定码不要泄露给其他人哦，会导致社区账号被冒用；</p>
        <p>2、一个绑定码只能绑定一个手机号，绑定后不可解绑；</p>
        <p>3、若有其他问题请联系游戏内客服。</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import http from '../../../../api/get';
import * as _code from '../../../../utils/code';
export default {
  name: 'loginCode',
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      password: '',
      eyesFlag: false,
      inoutTpye: 'password'
    };
  },
  mounted() {
    // alert(tejs);
    this.init();
  },
  methods: {
    init() {
      http.findLogincode().then((res) => {
        this.password = res.data.data;
      });
    },
    eyesClick() {
      this.eyesFlag = !this.eyesFlag;
      this.eyesFlag ? (this.inoutTpye = 'text') : (this.inoutTpye = 'password');
    },
    refresh() {
      //刷新登录码
      Dialog.confirm({
        title: '确认刷新登录码吗？',
        message: '刷新后需要重新登录微信公众号内社区'
      })
        .then(() => {
          http.refreshLogincode().then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              this.password = res.data.data;
            } else {
              this.errorMessage(rea.data);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onCopy() {
      Toast('复制成功！');
    },
    onError: function (e) {
      Toast('复制失败！');
    },
    backClick() {
      this.$parent.back();
      // this.$emit('changePage', 0);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>